/**
 *
 * Classe para formatar os dados do tipo texto
 * @author: Adalto Junior
 * DATE: 18/08/2014
 *
 */


Monet.Format = Monet.Format || {};
Monet.Format.LAT_LONG = (function () {

    function LAT_LONG(value) {

        Monet.Format.TEXT.apply(this, arguments);

        if( typeof value === null ||  typeof value === "undefined" ) {
            this.value = '';
        } else {
            this.value = value;
        }

        this.toGrid = function () {

            if (typeof this.value !== 'string') {
                this.value += '';
            }

            return this;

        };

    }

    return LAT_LONG;

}());